import Vue from 'vue';

import { PlbscfTypeList } from '@/classes/service/AbstractPlbscfService';
import { ValueType } from '@/master/Plbscf';

export default Vue.extend({
  name: 'CF計算書Mixin',

  methods: {
    recalculateByTypeLists(typeLists: PlbscfTypeList[]): void {
      for (const typeList of typeLists) {
        typeList.list.forEach((row) => {
          if (row.config.valueType !== ValueType.calcValue) return;
          row.yearValues.forEach((yv) => {
            if (yv.type !== undefined) return;
            this.$set(yv.item, 'value', undefined);
            this.$set(yv.item, 'yValue', undefined);
          });
        });
      }
    },
  },
});
